import Vue from 'vue'

const helper = {
    install(Vue, options) {
        Vue.prototype.$helper = {
            moneyFormat: function(amount, decimalCount = 2, decimal = ".", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.error('The value is not a float: '+e.message);
                }
            }
            ,axios_error(e) {
                // console.log('error', e);
                // console.log('error.response', e.response)
                let error = '';

                    let campos = e.response.data ? Object.keys(e.response.data) : e.response;
                    // console.log('campos', campos)

                if (!e.response || !e.response.data)
                    return Vue.prototype.$swal('Error',e.message,'error');;

                if (e.response.data.message) {
                    if (e.response.data.error) {
                        let campos = Object.keys(e.response.data.error);
                        let error = `${e.response.data.message}<ul class="sweetAlertError">`;

                        campos.forEach(campo => {
                            if (typeof(e.response.data.error[campo]) == 'string')
                                error += `<li>${e.response.data.error[campo]}</li>`;
                            else {
                                error += `<li>${campo}<ul>`;
                                e.response.data.error[campo].forEach(error => {
                                    error += `<li>${error}</li>`;
                                });
                                error +'</ul></li>'
                            }
                        });
                        error += '</ul>';

                        Vue.prototype.$swal('Error',error,'error');
                    }else {
                        Vue.prototype.$swal('Error',e.response.data.message,'error');
                    }
                }else {
                    Vue.prototype.$swal('Error',e.message,'error');
                }
            }
        }
    }
}

Vue.use(helper);